export default __webpack_public_path__ + "static/media/ISGB.c53dc759.jpg";